import { Stack } from "@fluentui/react/lib/Stack";

import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { AutoComplete } from "./AutoComplete";
import { Chip } from "./Chip";
import { ISearchProps } from "./ISearchProps";
import { SearchContextProvider, WithSearchContext } from "./SearchContext";
import { useSearchStyles } from "./UseSearchStyles";

const SearchInternal = WithTheme(
  WithSearchContext((props: ISearchProps): JSX.Element => {
    const {
      onEdit,
      onRemove,
      tokenSetList,
      theme: { spacing }
    } = props;
    const styles = useSearchStyles();

    return (
      <Stack tokens={{ childrenGap: spacing.s2 }}>
        <AutoComplete />
        <Stack.Item align="start">
          <Stack className={styles.chipWrap} horizontal wrap tokens={{ childrenGap: 10 }}>
            {tokenSetList.map(([fieldName, search]) => (
              <Chip
                key={`${fieldName}:${search}`}
                fieldName={fieldName}
                onEdit={onEdit}
                onRemove={onRemove}
                search={search}
              />
            ))}
          </Stack>
        </Stack.Item>
      </Stack>
    );
  })
);

export function Search(): JSX.Element {
  return (
    <SearchContextProvider>
      <SearchInternal />
    </SearchContextProvider>
  );
}
